import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { PageHero } from 'organisms'

const GRIEVANCE_HTML_URL = `${process.env.PUBLIC_URL}/grievance-redressal-and-disclosures.html`
const GRIEVANCE_POLICY_PDF_URL = `${process.env.PUBLIC_URL}/pdf/ProsParity_Grievance_Redressal_Policy.pdf`

function resizeIframe(iframe: HTMLIFrameElement) {
  const doc = iframe.contentDocument
  if (!doc) return

  iframe.style.height = `${doc.documentElement.scrollHeight}px`
}

function prepareEmbeddedPage(iframe: HTMLIFrameElement) {
  const doc = iframe.contentDocument
  if (!doc) return

  doc.querySelector('.nav')?.remove()
  doc.querySelector('.foot')?.remove()

  const subnav = doc.querySelector('.subnav') as HTMLElement | null
  if (subnav) {
    subnav.style.top = '0'
  }

  const downloadLink = doc.querySelector('.hero__download') as HTMLAnchorElement | null
  if (downloadLink) {
    downloadLink.href = GRIEVANCE_POLICY_PDF_URL
    downloadLink.setAttribute(
      'download',
      'ProsParity_Grievance_Redressal_Policy.pdf',
    )
  }

  doc.documentElement.style.scrollPaddingTop = '72px'
  resizeIframe(iframe)
}

export default function GrievanceRedressalAndDisclosures() {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe) return

    let observer: ResizeObserver | undefined

    const handleLoad = () => {
      prepareEmbeddedPage(iframe)

      const doc = iframe.contentDocument
      if (!doc) return

      observer?.disconnect()
      observer = new ResizeObserver(() => resizeIframe(iframe))
      observer.observe(doc.documentElement)
    }

    iframe.addEventListener('load', handleLoad)

    return () => {
      iframe.removeEventListener('load', handleLoad)
      observer?.disconnect()
    }
  }, [])

  return (
    <>
      <PageHero title="Grievance Redressal & Disclosures" />

      <iframe
        ref={iframeRef}
        src={GRIEVANCE_HTML_URL}
        title="Grievance Redressal & Disclosures"
        className="block w-full border-0 bg-white"
        style={{ minHeight: '480px' }}
      />
    </>
  )
}
